import { useCallback } from 'react';
import { useSelector } from 'react-redux';

const useFeatureFlagsForAccounts = () => {
    const { features_flags } = useSelector(state => ({
        features_flags: state.featuresFlags.features_flags
    }))

    const isFeatureFlagActiveForAccount = useCallback((flag_name, account) => {
        const ff_flag = features_flags.find(
            ff => ff.key === flag_name
        );
        const enabled_universally = ff_flag?.state === "on" ? true : false;
        const flipper_account_id = account?.id ? 'Account;' + account.id : null;
        const enabled_for_account = flipper_account_id && ff_flag?.gates?.find(e => e.key === 'actors' && e.value?.includes(flipper_account_id)) ? true : false;
        return enabled_universally || enabled_for_account;
    }, [features_flags])

    return [isFeatureFlagActiveForAccount];
}

export default useFeatureFlagsForAccounts;